import { render, staticRenderFns } from "./TablePOChangeNew.vue?vue&type=template&id=0d13392d&scoped=true&"
import script from "./TablePOChangeNew.vue?vue&type=script&lang=js&"
export * from "./TablePOChangeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d13392d",
  null
  
)

export default component.exports